const Form074EN = {
    stepName: {
        importantNotes: "Important Notes",
        selectSchool: "Selection of school type",
        basicInfo: "Basic Information",
        confirmation: "Confirmation",
    },
    label: {
        noteHeader: {
            header1: "Education Bureau Circular No. 6/2010",
            header2:
                "Payment and Accounting Arrangements for Subsidy for Employer’s Provident Fund/Mandatory Provident Fund Contributions in respect of Staff in Aided Schools Employed under Administration Grant/Revised Administration Grant",
            header3: "[Note : This circular should be read by",
            header4:
                "(a) Supervisors and Heads of all aided schools – for action; and",
            header5: "(b) Heads of Sections – for information.]",
        },
        noteTitle: {
            title1: "Summary",
            title2: "Background",
            title3: "Details",
            title4: "Enquiries",
        },
        noteList: {
            refNo: "Ref : FIN(RS)/F&A/65/63",
            EDB: "Government of the HKSAR Education Bureau",
            date: "6 July 2010",
            note1: "This circular sets out the payment and accounting arrangements for subsidy for employer’s Provident Fund / Mandatory Provident Fund (MPF) contributions in respect of staff in aided schools who are employed under Administration Grant/Revised Administration Grant. It should be read in conjunction with the prevailing EDB circular(s) on the funding of retirement benefits for staff of aided schools.",
            note2: "Aided schools are provided with Administration Grant/Revised Administration Grant for making salary payment to staff employed under the Grants. Subsidy is also separately provided to aided schools to meet their actual expenditure on the employer’s Provident Fund/MPF contributions in respect of these staff.",
            note3: "With effect from 2010/11 school year, the payment process for the subsidy for employer’s Provident Fund/MPF contributions will be streamlined in order to save administrative efforts in aided schools.",
            note4: "The revised payment and accounting arrangements are set out below –",
            note5: "Schools should submit the claim form for the provisional annual employer’s Provident Fund/MPF contributions (Annex 1) <u>for the coming school year</u> in respect of staff employed under Administration Grant/Revised Administration Grant to the Recurrent Subventions Section of Education Bureau (EDB) before 15 August each year. The relevant form can be downloaded from EDB Homepage (School Administration and Management > Regulations > Codes of Aid > Guidelines and Forms related to Codes of Aid for Aided Primary, Secondary and Special Schools);",
            note6: "In completing the claim form in (a) above, schools should provide their latest estimate of the employer’s Provident Fund/MPF contributions for the coming school year to the best of their knowledge and certify that the information provided are correct and complied with relevant circulars. Supporting documents to substantiate the payments of salaries and Provident Fund/MPF contributions by schools need <u>not</u> be provided to the Recurrent Subventions Section but should be kept at schools;",
            note7: "Based on the provisional claim at (a), schools will receive the subsidy for employer’s Provident Fund/MPF contributions at the same time when Administration Grant/Revised Administration Grant is paid to schools, i.e. quarterly payment to IMC schools in September, November, February and May, and monthly payment to non-IMC schools starting from September;",
            note8: "Schools should continue to include a schedule detailing the staff employed by Administration Grant/Revised Administration Grant and their related Provident Fund/MPF contributions in their audited accounts in accordance with the prevailing circular memorandum calling for submission of audited accounts, for submission to the School Audit Section of Education Bureau; and",
            note9: "Any excess subsidy paid will be clawed back from schools while any shortfall will be reimbursed to schools after the examination of audited accounts by the School Audit Section.",
            note10: "If you have any enquiries on this circular, please contact the Recurrent Subventions Section – ",
            note11: "Primary schools",
            note12: "2892 6232",
            note13: "Secondary schools",
            note14: "2892 6233",
            note15: "Special schools",
            note16: "2892 6234",
            note17: "Mrs Lily Tsang",
            note18: "for Permanent Secretary for Education",
        },
        noteNumber: {
            number2: "2.",
            number3: "3.",
            number4: "4.",
            number5: "5.",
            numbera: "(a)",
            numberb: "(b)",
            numberc: "(c)",
            numberd: "(d)",
            numbere: "(e)",
            numbera1: "a)",
            numberb1: "b)",
        },
        certifyList: {
            certify1:
                "I certify that staff paid under Administration Grant/Revised Administration Grant will –",
            certify2:
                "receive salaries, less their employee’s PF contribution at 5% or MPF contributions which is capped at the amount as stipulated in MPF Ordinance, where appropriate, in the coming school year. ",
            certify3:
                "receive employer’s provident fund contributions on the basis of the respective employee’s continuous contributory service under the condition of the approved scheme and the conditions to be met for higher rate of employer’s PF contribution as stated in the prevailing EDB circular(s) on the funding of retirement benefits for staff of aided schools.",
            certify4:
                "I understand that subsidy will only be provided for PF/MPF contributions in respect of staff employed within the provision allocated for Administration Grant / Revised Administration Grant and EDB will reimburse the shortfall of the actual employer’s PF contributions or clawback the unspent balance, where appropriate, based on audited accounts. The data collected in this form is used for calculation of the provisional annual employer’s PF/MPF contributions and other related purposes. It may be disclosed to the other Government bureaux/departments/agencies for audit/statistical purposes.",
        },
        detail: "Details of Provisional Annual Employer’s PF/MPF Contributions",
        totalSchoolYear: "Total for the school year",
        totalLastSchoolYear: "Total for the last school year",
        certify: "Certification",
        tooltip:
            "There is no PF / MPF subsidy for staff employed under the Administration Grant for Additional Clerical Assistant for aided primary schools.",
        conditions:
            "I have read, understood and agreed to the above terms and conditions.",
        schoolType: "Please select the school type:",
        schoolName: "Name of School",
        schoolCode: "School Code",
        schoolYear: "School Year",
        grantType: "Grant applicable to the school",
        rank: "Rank",
        numStaff: "No. of Staff",
        provisionalAnnSal:
            "Provisional Total Annual Salary for the school year",
        provisionalAnnEmpCon:
            "Provisional Annual Employer’s PF/MPF Contributions",
        totalNumStaff: "Total for the school year (No. of Staff)",
        totalNumStaff1: "No. of Staff",
        totalProvisionalAnnSal:
            "Total for the school year (Provisional Total Annual Salary for the school year)",
        totalProvisionalAnnSal1:
            "Provisional Total Annual Salary for the school year",
        totalProvisionalAnnEmpCon:
            "Total for the school year (Provisional Annual Employer’s PF/MPF Contributions)",
        totalProvisionalAnnEmpCon1:
            "Provisional Annual Employer’s PF/MPF Contributions",
        numStaffLastYr: "Total for last school year (No. of Staff)",
        provisionalAnnSalLastYr:
            "Total for last school year (Provisional Total Annual Salary for the school year)",
        provisionalAnnEmpConLastYr:
            "Total for last school year (Provisional Annual Employer’s PF/MPF Contributions)",
        schoolHead: "School Head",
        supervisor: "Supervisor",
        schoolHeadOrSupervisor: "Supervisor/School Head",
        schoolHeadName: "Name of School Head",
        supervisorName: "Name of Supervisor",
        schoolHeadOrSupervisorName: "Name of Supervisor/School Head",
        name: "name",
        date: "Date",
        contactPerson: "Contact Person",
        tel: "Tel No.",
    },
    formContent: {
        schoolTypeOption: {
            primarySchool: "Aided Primary Schools",
            secondarySchool: "Aided Secondary Schools",
            specialSchool: "Aided Special Schools",
        },
        grantTypeOption: {
            administrationGrant: "Administration Grant",
            revisedAdministrationGrant: "Revised Administration Grant",
        },
        schoolHeadOption: {
            schoolHead: "School Head",
            supervisor: "Supervisor",
        },
    },
    errorMsg: {
        telMax: "Telephone number must be at most 12 digits",
    },
};

export default Form074EN;
